import { render, staticRenderFns } from "./SupportAccess.vue?vue&type=template&id=09754468"
import script from "./SupportAccess.vue?vue&type=script&lang=js"
export * from "./SupportAccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports